import { useRef, useState, useEffect } from "react";

interface ResizerConfig {
    code: string;
    type: 'width' | 'height';
    storageKey: string;
    min: number;
    max: number;
    default: number;
	option?: {
		browserMaxHeight?: number; // 각 화면마다 부여되는 높이가 다를수 있음
	}
}

interface Props {
	resizer: ResizerConfig;
	// minLeftWidth?: number; maxLeftWidth?: number;
	// minUpDownWidth?: number; maxUpDownWidth?: number;
	isResizing: React.MutableRefObject<boolean>;
	// leftWidth?: number;			setLeftWidth?: (leftWidth: number) => void;
	// topHeight?: number;				setTopHeight?: (topHeight: number) => void;
    containerRef: React.RefObject<HTMLDivElement | null>;
	infoRef?: React.RefObject<HTMLDivElement | null>;
}

//단일 차트 영역 조정
export const useMouseContent = (props: Props) => {

	const browserMaxHeightDefault = 100;
    
	const { 
			resizer = {
				code: '',
				type: 'width',
				storageKey: '',
				min: 0,
				max: 100,
				default: 0,
				option: {
					browserMaxHeight: browserMaxHeightDefault,
				}
			},
			// minLeftWidth = 50, maxLeftWidth = 100,
			// minUpDownWidth = 50, maxUpDownWidth = 100,
			isResizing,
			// leftWidth, setLeftWidth,
			// topHeight, setTopHeight,
			containerRef,
			infoRef = undefined
	} = props;

	
        // localStorage에서 저장된 값 가져오기
	const savedValue = typeof window !== 'undefined' ? localStorage.getItem(resizer.storageKey) : null;
	const [splitValue, setSplitValue] = useState(
		savedValue ? Number(savedValue) : resizer.default
	);

	const validateMouseMoveHandler = (currentMouseMoveHandler: (event: MouseEvent) => void, type: 'LR' | 'LR2' | 'UD') => {
		if (type === 'LR') {
			currentMouseMoveHandler = handleMouseMoveLR; 
		} else if (type === 'LR2') {
			currentMouseMoveHandler = handleMouseMoveLR2;
		} else if (type === 'UD') {
			currentMouseMoveHandler = handleMouseMoveUD; // 함수 자체를 할당
		} else {
			// 기본 핸들러도 올바른 시그니처를 갖도록 함
			currentMouseMoveHandler = (event: MouseEvent) => {};
		}
		return currentMouseMoveHandler;
	}

	const handleMouseDown = (type: 'LR' | 'LR2' | 'UD', e: MouseEvent) => {

		console.log(type);

		let onMouseMove : (event: MouseEvent) => void = (event: MouseEvent) => {};
		onMouseMove = validateMouseMoveHandler(onMouseMove, type);
		

		//handleMouseDown 함수는 마우스를 클릭하고 유지할때 발동하는 함수이므로 이 값을 true로 한다
		isResizing.current = true;
		//infoRef가 있으면 해당 영역이 커서에 드래그되지 않게 처리 < 다른 컴포넌트가 none처리되지 않아서 이 코드는 보류
		// if (infoRef && infoRef.current) {
		// 	infoRef.current.style.userSelect = 'none';
		// }
		const onMouseUp = () => {
			document.removeEventListener('mousemove', onMouseMove);
			document.removeEventListener('mouseup', onMouseUp);
		};
	
		document.addEventListener('mousemove', onMouseMove);
		document.addEventListener('mouseup', onMouseUp); // handleMouseUp 대신 내부 onMouseUp 사용
	};
	
	//좌우 차트 리사이징
	const handleMouseMoveLR = (e: MouseEvent) => {
		// console.log('handleMouseMoveLR isResizing.current', isResizing.current);
		// console.log('handleMouseMoveLR containerRef.current', containerRef.current);
		if (!isResizing.current || !containerRef.current) return;
	
		const containerWidth = containerRef.current.getBoundingClientRect().width;
		const offsetX = e.clientX - containerRef.current.getBoundingClientRect().left;
		const newLeftWidth = (offsetX / containerWidth) * 100;
		
		if (setSplitValue && newLeftWidth >= resizer.min && newLeftWidth <= resizer.max) {
		  setSplitValue(Math.floor(newLeftWidth));
		}else if(!setSplitValue){
			console.log('setLeftWidth is undefined');
		}
	};

	const handleMouseMoveLR2 = (e: MouseEvent) => {
		// console.log('handleMouseMoveLR2 isResizing.current', isResizing.current);
		// console.log('handleMouseMoveLR2 containerRef.current', containerRef.current);

		if (!isResizing.current || !containerRef.current) return;

		const containerWidth = containerRef.current.getBoundingClientRect().width;
		const offsetX = e.clientX - containerRef.current.getBoundingClientRect().left;
		const newLeftWidth = (offsetX / containerWidth) * 100;
		
		if (setSplitValue && newLeftWidth >= resizer.min && newLeftWidth <= resizer.max) {
			setSplitValue(Math.floor(newLeftWidth));
		}else if(!setSplitValue){
			console.log('setLeftWidth is undefined');
		}
	};

	const handleMouseMoveUD = (e: MouseEvent) => {
		// console.log('handleMouseMoveUD isResizing.current', isResizing.current);
		// console.log('handleMouseMoveUD containerRef.current', containerRef.current);
		if (!isResizing.current || !containerRef.current) return;

		const containerHeight = containerRef.current.getBoundingClientRect().height;
		const offsetY = e.clientY - containerRef.current.getBoundingClientRect().top;
		const newTopHeight = (offsetY / containerHeight) * (resizer.option?.browserMaxHeight || browserMaxHeightDefault) + 1;

		// console.log('newTopHeight', newTopHeight);
		if (setSplitValue && newTopHeight >= resizer.min && newTopHeight <= resizer.max) {
			setSplitValue(Math.floor(newTopHeight));
		}else if(!setSplitValue){
			console.log('setTopHeight is undefined');
		}
	}
	
	//handleMouseUp은 handleMouseDown에서 생성된 함수를 참조하므로, 여기서 기록되는 onMouseMove은 handleMouseDown에서 기록된 onMouseMove와 동일한 함수를 참조하게 된다.
	const handleMouseUp = (e: MouseEvent) => {

		
		let onMouseMove : (event: MouseEvent) => void = (event: MouseEvent) => {};
		onMouseMove = validateMouseMoveHandler(onMouseMove, 'UD');

		//handleMouseUp 함수는 마우스를 클릭하고 놓을때 발동하는 함수이므로 이 값을 false로 한다
		isResizing.current = false;
		localStorage.setItem(resizer.storageKey, splitValue.toString());
		document.removeEventListener('mousemove', onMouseMove);
		document.removeEventListener('mouseup', handleMouseUp);
	};

	

	useEffect(() => {
		if (typeof window !== 'undefined') {
			localStorage.setItem(resizer.storageKey, splitValue.toString());
		}
	}, [splitValue]);

    return {
        splitValue,
        setSplitValue,
		handleMouseDown,
		handleMouseUp
    }
    
}
